import React, { useState, useEffect, memo, useRef } from 'react';
import { TransformWrapper, TransformComponent, ReactZoomPanPinchRef } from 'react-zoom-pan-pinch';
import Hammer from 'hammerjs';
import style from "./../index.module.scss";
import styleUi from "./FixPhoto.module.scss";
import { CSSTransition } from 'react-transition-group';
import * as YStyled from "../../Styleds";

const FixPhoto = ({ setModalType, arg, addModalType }) => {
    const [inProp, setInProp] = useState(false);
    const [rotation, setRotation] = useState(0);
    const rotationRef = useRef(0);
    const [scale, setScale] = useState(arg.minScale);
    const lastRotationRef = useRef(0);
    const imageRef = useRef(null);
    const transformRef = useRef(null);
    const lastPositionRef = useRef({ x: 0, y: 0 });

    useEffect(() => {
        rotationRef.current = rotation;
    }, [rotation]);
    useEffect(() => {
        setInProp(true);
        document.title = "設定頭像";
        const imgElement = imageRef.current;
        const hammer = new Hammer(imgElement);

        hammer.add(new Hammer.Pan({ enable: true }));
        hammer.add(new Hammer.Rotate({ enable: true }));

        hammer.on('rotatestart', (e) => {
            lastRotationRef.current = e.rotation;
        });

        hammer.on('rotatemove', (e) => {
            const deltaAngle = e.rotation - lastRotationRef.current;
            setRotation(prevRotation => prevRotation + deltaAngle);
            lastRotationRef.current = e.rotation;
        });
        hammer.on('panstart', (e) => {
            console.log("panstart")
            lastPositionRef.current = { x: e.deltaX, y: e.deltaY };
        });

        hammer.on('panmove', (e) => {
            const { x: lastX, y: lastY } = lastPositionRef.current;
            let deltaX = e.deltaX - lastX;
            let deltaY = e.deltaY - lastY;


            // 更新位置
            const { scale, positionX, positionY } = transformRef.current.instance.transformState;
            const r = rotationRef.current * (Math.PI / 180);
            console.log("rotation", rotationRef.current)
            deltaX = deltaX * -1;
            const _x = deltaX * Math.cos(r) - deltaY * Math.sin(r);
            const _y = deltaX * Math.sin(r) + deltaY * Math.cos(r);
            transformRef.current.setTransform(
                positionX - _x,
                positionY + _y,
                scale,
                0
            );

            lastPositionRef.current = { x: e.deltaX, y: e.deltaY };
        });

        return () => {
            hammer.destroy(); // 清理事件监听器
        };
    }, [scale]);

    const handleZoom = (ref, event) => {
        if (ref.state) {
            setScale(ref.state.scale);
        }
    };

    function getImg() {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        const { scale, positionX, positionY } = transformRef.current.instance.transformState;
        const cropSize = transformRef.current.instance.contentComponent.offsetWidth;
        const image = new Image();
        image.src = arg.imageUrl;
        const viewImgSize = cropSize * scale;
        image.onload = () => {
            const { width, height } = image;
            const realScale = width / viewImgSize;
            canvas.width = cropSize;
            canvas.height = cropSize;
            const rotationAngle = rotationRef.current * (Math.PI / 180); // 将度数转换为弧度
            context.translate(cropSize / 2, cropSize / 2); // 将原点移动到画布的中心
            context.rotate(rotationAngle); // 应用旋转
            context.translate(-cropSize / 2, -cropSize / 2); // 将原点移动回画布的左上角
            const drawX = -positionX * realScale;
            const drawY = -positionY * realScale;
            const range = cropSize * realScale;
            context.drawImage(image, drawX, drawY, range, range, 0, 0, cropSize, cropSize);
            const croppedDataUrl = canvas.toDataURL('image/png');
            console.log("croppedDataUrl", croppedDataUrl);
            arg.cb(croppedDataUrl);
            setInProp(false);
        };
    }

    return (
        <div className={style.modal}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.SwipePageEnterActive,
                enterDone: style.SwipePageEnterDone,
                exitActive: style.SwipePageExit,
                exitDone: style.SwipePageExitActive
            }}
                onExited={async () => {
                    await new Promise(resolve => requestAnimationFrame(resolve));
                    setModalType(prev => prev.filter(v => v.cls !== "FixPhoto"))
                }}
            >
                <div className={`${style.SwipePage} ${style.Page}`}>
                    <div className={styleUi.app}>
                        <div className={styleUi.headerBar}>
                            <img src="./assets/ui/back.png" onClick={e => { setInProp(false) }} />
                            <YStyled.Span fontWeight={500} size={17}>設定頭像</YStyled.Span>
                            <img src="./assets/ui/back.png" />
                        </div>
                        <div className={styleUi.view} ref={imageRef}>
                            <div className={styleUi.mask} />
                            <div className={styleUi.photo} style={{ transform: `rotate(${rotation}deg)` }}>
                                <TransformWrapper
                                    minScale={arg.minScale}
                                    maxScale={20}
                                    initialScale={arg.minScale}
                                    wheel={{ step: 5 }}
                                    centerOnInit={true}
                                    limitToBounds={true}
                                    onZoom={handleZoom}
                                    ref={transformRef}
                                    panning={{ disabled: true }}
                                >
                                    <TransformComponent>
                                        <img src={arg.imageUrl} alt="Headshot" style={{ width: '100%', height: '100%' }} />
                                    </TransformComponent>
                                </TransformWrapper>
                            </div>
                        </div>
                        <YStyled.Row style={{ position: "absolute", bottom: "40px", padding: "1rem" }}>
                            <YStyled.BTN3 normalBg="#F2CE3E" normalColor="black" style={{ marginTop: "5rem", width: "100%", borderRadius: "6px", padding: ".8rem", borderWidth: "0px" }} onClick={e=>{
                                getImg();
                            }}>
                                <YStyled.Span size={17} >套用</YStyled.Span>
                            </YStyled.BTN3>
                        </YStyled.Row>
                    </div>
                </div>
            </CSSTransition>
        </div>
    );
};

export default memo(FixPhoto);
